import { CookieKeys } from '@/constants/commons'
import type { LoginPendingAction } from '@/types/member'

// PM asked to set 3 mins
const LOGIN_CALLBACK_COOKIE_MAX_AGE = 180

export function useLoginPendingActionCookie() {
  return useCookie<Nullable<LoginPendingAction>>(CookieKeys.LOGIN_CALLBACK, { maxAge: LOGIN_CALLBACK_COOKIE_MAX_AGE })
}
